// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ab40659a","199":"e5abc832","436":"07ea308d","448":"4ea7e9c4","453":"258b012d","675":"57382665","813":"0037a36d"}[chunkId] + ".chunk.js";
};